
import ImagesLoaded from 'vue-images-loaded';
export default ImagesLoaded;



// WEBPACK FOOTER //
// ./src/vue/directives/images-loaded.js